import React from 'react';
import { useNavigate } from 'react-router-dom';
import ShippingMethodSelection from '../components/ShippingMethodSelection';
import PaymentMethodSelection from '../components/PaymentMethodSelection';
import ShippingAddress from '../components/ShippingAddress';

const ShippingPayment = () => {
  const navigate = useNavigate();
  const handleSubmitOrder = () => {
    navigate('/order');
  };

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900">Livraison & Paiement</h2>
        <p className="text-slate-500 text-sm mt-1">Remplissez vos coordonnées pour valider la commande.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-6">
          <ShippingAddress />
        </div>
        <div className="space-y-6">
          <ShippingMethodSelection />
          <PaymentMethodSelection />
        </div>
      </div>

      <div className="flex justify-end pt-4 border-t border-slate-200">
        <button
          onClick={handleSubmitOrder}
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg font-medium text-sm transition-colors shadow-sm shadow-indigo-600/10"
        >
          Valider
        </button>
      </div>
    </div>
  );
};

export default ShippingPayment;
